import { css } from "@emotion/core";

export const consultationFeedbackFormStyles = {
  container: (isMobile: boolean) => {
    return {
      textAlign: "left",
      margin: isMobile ? "16px -40px -40px -40px" : "16px -30px -30px -30px",
      backgroundColor: "rgb(235, 239, 244)",
      padding: "12px 16px",
      borderRadius: isMobile ? 0 : 5
    }
  },
  mainQuestionRow: (isMobile: boolean) => {
    return {
      display: isMobile ? "block" : "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontFamily: "BrandonTextWeb-Medium"
    }
  },
  mainQuestionText: (isMobile: boolean) => {
    if (isMobile) {
      return {
        marginBottom: 12
      }
    }
  },
  submitMsg: {
    textAlign: "left",
    color: "rgb(44, 44, 44)",
    marginTop: 20,
    fontFamily: "BrandonTextWeb-Medium"
  },
  submitIcon: {
    marginLeft: 12
  },
  subQuestion: {
    color: "rgb(102, 102, 102)",
    fontFamily: "BrandonTextWeb-Regular",
    fontSize: 12
  },
  tabsContainer: {
    display: "flex",
    marginBottom: 20,
    marginTop: 20
  },
  commentSubmitContainer: {
    display: "flex",
    alignItems: "center"
  }
}

export const commentBoxStyle = css`
  border: 0;
  background: transparent;
  border-bottom: 1px solid rgba(145, 151, 171, 0.5);
  outline-style: none;
  margin-top: 20px;
  width: 100%;
  padding: 8px 0;
  margin-bottom: 20px;
  margin-right: 28px;

  &::-webkit-input-placeholder {
    font-style: italic;
  }
  &:-moz-placeholder {
    font-style: italic;  
  }
  &::-moz-placeholder {
    font-style: italic;  
  }
  &:-ms-input-placeholder {  
    font-style: italic; 
  }
`;

export const tabStyle = (isSelected: boolean) => {
  const baseStyle: any = {
    fontSize: 14,
    fontFamily: "BrandonTextWeb-Bold",
    color: "rgba(0, 0, 0, 0.85)",
    borderBottom: "2px solid #ebeff4",
    padding: "8px 0",
    cursor: "pointer",
    marginRight: 16
  }

  if (isSelected) {
    baseStyle.borderColor = "#ff316d";
  }
  return baseStyle;
}